import { useRef, useState } from "react";
import Icon from "../Icons/Icon";
import "./ConfirmPrompt.css";
import { Row, Col, Modal, Button, Form } from 'react-bootstrap'

export default function useConfirm() {
    const [message, setMessage] = useState(null);
    const resolverRef = useRef(null);

    const confirm = (msg) => {
        setMessage(msg);

        return new Promise((resolve) => {
            resolverRef.current = resolve;
        });
    };

    const handleClose = (result) => {
        if (resolverRef.current) {
            resolverRef.current(result);
            resolverRef.current = null;
        }
        setMessage(null);
    };

    const ConfirmDialog = message ? (
        <div>
        <Row className='mb-3'>
            <Col className='confirm-message-icon'>
                 <Icon name="BsShieldFillExclamation" />
                
            </Col>
            </Row>
            <Row className='mb-3'>
                <Col className='confirm-message-message'>
                    {message}
                </Col>
            </Row>
            <Row className='mb-3'>
                <Col className='confirm-message-buttons'>
                    <Button onClick={() => handleClose(false)} variant="outline-primary">No</Button> &nbsp;&nbsp;
                    <Button onClick={() => handleClose(true)}>Yes</Button>
                </Col>
            </Row>
        </div> 
        //<div className="confirm-message">
        //    <div className='confirm-message-icon'>
        //         <Icon name="BsShieldFillExclamation" />              
        //    </div>
        //    <div className='confirm-message-message'>
        //        <p>{message}</p>
        //        <button onClick={() => handleClose(true)}>Yes</button>
        //        <button onClick={() => handleClose(false)}>No</button>
        //    </div>
        //</div>
    ) : null;

    return { confirm, ConfirmDialog };
}
